import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CustomerLogin from "./components/Customer/CustomerLogin";
import CustomerDashboard from "./components/Customer/CustomerDashboard";
import CustomerProfile from "./components/Customer/CustomerProfile";
import CustomerRegister from "./components/Customer/CustomerRegister";
import CustomerPurchaseList from "./components/Customer/CustomerPurchaseList";
import FreeStringingServices from "./components/Customer/FreeStringingServices";
import NotificationList from "./components/NotificationList";
import StaffRegister from "./components/Staff/StaffRegister";
import AdminLogin from "./components/Admin/AdminLogin";
import CreateCustomer from "./components/AdminCreate/CreateCustomer";
import ManageCustomer from "./components/AdminCreate/ManageCustomer";
import CreatePurchase from "./components/AdminCreate/CreatePurchase";
import ManagePurchase from "./components/AdminCreate/ManagePurchase";
import SetPassword from "./components/Staff/SetPassword";
import CustomerSetPassword from "./components/Customer/CustomerSetPassword";
import Dashboard from "./components/Admin/Dashboard";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AdminProfile from "./components/Admin/AdminProfile";
import AdminApproval from "./components/AdminApproval/AdminApproval";
import CustomerDetails from "./components/Details/CustomerDetails";
import TicketDetails from "./components/Details/TicketDetails";
import DetailedTicket from "./components/Details/DetailedTicket";
import CreateTicket from "./components/Customer/CreateTicket";
import CustomerTransactions from "./components/Customer/CustomerTransactions"
import TickerResponse from "./components/AdminCreate/TicketResponse/TicketResponse";

const App = () => {
  return (
    <Router basename="/">
      <div>
        <Routes>
          <Route path="/customer/login" element={<CustomerLogin />} />
          <Route path="/register" element={<CustomerRegister />} />
          <Route path="/customer/dashboard" element={<CustomerDashboard />}>
            <Route index element={<CustomerPurchaseList />} />
            <Route path="profile" element={<CustomerProfile />} />
            <Route path="purchases" element={<CustomerPurchaseList />} />
            <Route path="services" element={<FreeStringingServices />} />
            <Route path="create-ticket" element={<CreateTicket />} />
            <Route
              path="your-transactions"
              element={<CustomerTransactions />}
            />
          </Route>
          <Route path="/notifications" element={<NotificationList />} />
          <Route
            path="/admin/purchases/create/:customerId"
            element={<CreatePurchase />}
          />
          <Route path="/admin/register" element={<StaffRegister />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />}>
            <Route index element={<Dashboard />} />
            <Route path="create-customer" element={<CreateCustomer />} />
            <Route path="manage-customer" element={<ManageCustomer />} />
            <Route path="manage-purchase" element={<ManagePurchase />} />
            <Route
              path="create-purchase/:customerId"
              element={<CreatePurchase />}
            />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="customer-details" element={<CustomerDetails />} />
            <Route path="ticket-details" element={<TicketDetails />} />
            <Route path="detailed-ticket/:ticketId" element={<DetailedTicket />} />
            <Route path="ticket-response" element={<TickerResponse />} />
          </Route>
          <Route path="/pending-requests" element={<AdminApproval />} />
          <Route path="/set-password" element={<CustomerSetPassword />} />
          <Route path="/admin/set-password" element={<SetPassword />} />
          <Route path="/" element={<AdminLogin />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
